import { Fragment } from "react";

import { prop, define } from "@/components/builder/utils";

import BasePreview from "../../../base";
import { useFormFieldContext } from "../context";

function FormH5Preview({ ...props }) {
  const { field: { label } } = useFormFieldContext()

  return <BasePreview {...props}>
    <h5>{label}</h5>
  </BasePreview>
}

export default define('form-heading-h5', FormH5Preview, Fragment)
  .shared(prop.share('FormH5', 'form-heading-h5'))
  .property(prop.predefined.customClass())
  .property(...prop.predefined.appearance())
  .property(...prop.predefined.typography())
  .build()

